import React, { useState, useEffect, useCallback } from 'react'
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { Numeral } from '../../../numeral/Numeral';
import { CardGiftcard } from '@mui/icons-material';

import { ConfettiContainer, Confetti, StyledDialog, AnimatedTypography } from './RewardModal.styles';

export function RewardModal({
    isOpen,
    closeModal,
    initialPoints,
    finalPoints,
    dialogTitle,
    dialogContent,
    operation,
}) {
    const [currentPoints, setCurrentPoints] = useState(initialPoints);
    const isIncreasing = finalPoints > initialPoints;
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const animatePoints = useCallback(() => {
        const duration = 2000 // 2 seconds
        const frames = 60
        const change = (finalPoints - initialPoints) / frames
        let count = 0

        const intervalId = setInterval(() => {
            count++
            setCurrentPoints(prevPoints => {
                const newPoints = prevPoints + change
                if (isIncreasing) {
                    return newPoints >= finalPoints ? finalPoints : newPoints
                } else {
                    return newPoints <= finalPoints ? finalPoints : newPoints
                }
            })

            if (count >= frames) {
                clearInterval(intervalId)
            }
        }, duration / frames)
    }, [finalPoints, initialPoints, isIncreasing]);

    useEffect(() => {
        if (isOpen) {
            setCurrentPoints(initialPoints);
            const timer = setTimeout(() => {
                animatePoints()
            }, 500)
            return () => clearTimeout(timer)
        }
    }, [isOpen, initialPoints, finalPoints, animatePoints]);

    return (
        <StyledDialog open={isOpen} onClose={closeModal} maxWidth="sm" fullWidth>
            <ConfettiContainer>
                {[...Array(20)].map((_, i) => (
                    <Confetti key={i} style={{ left: `${Math.random() * 100}%`, animationDelay: `${Math.random() * 3}s` }} />
                ))}
            </ConfettiContainer>

            <DialogTitle>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2
                    }}>
                    <Box
                        sx={{
                            width: isMobile ? 60 : 80,
                            height: isMobile ? 60 : 80,
                            borderRadius: '50%',
                            backgroundColor: '#FF8891',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            mb: isMobile ? 1 : 2,
                        }}
                    >
                        <CardGiftcard sx={{ fontSize: isMobile ? 30 : 40, color: '#F5F2FC' }} />
                    </Box>
                    <Typography style={{ fontFamily: 'GT Walsheim Pro', fontWeight: '600', color: '#687099' }} className='text-md' variant={isMobile ? "h6" : "h4"} align="center" gutterBottom >
                        {dialogTitle}
                    </Typography>
                </Box>

            </DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 1
                    }}>
                    <AnimatedTypography
                        style={{
                            fontFamily: 'GT Walsheim Pro',
                            fontWeight: '600',
                            color: '#687099'
                        }}
                        variant={isMobile ? "h6" : "h4"}
                        component="div" >
                        {dialogContent}{" "}
                    </AnimatedTypography>

                    <AnimatedTypography
                        width={isMobile ? '250px' : '300px'}
                        margin={isMobile ? '0px' : 'auto'}
                        variant={isMobile ? "h3" : "h2"}
                        component="div"
                        color="#7E02FC"
                        gutterBottom
                        style={{ marginBottom: '0.3em', marginTop: '0.4em', fontFamily: 'GT Walsheim Pro' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                            <span className="font-bold">+</span>
                            <Numeral
                                className="font-bold"
                                format={"$0,0"}
                                value={operation === 'cupo' ? Math.abs(Math.round(currentPoints)) : Math.abs(Math.round(currentPoints - initialPoints))} />
                        </div>
                    </AnimatedTypography>
                </Box>
            </DialogContent>
            <DialogActions>
                <button
                    onClick={closeModal}
                    style={{ fontFamily: 'GT Walsheim Pro', cursor: "pointer" }}
                    type="button"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-xs text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-hidden"
                >
                    <div className="flex">
                        ¡Genial!
                    </div>
                </button>
            </DialogActions>
        </StyledDialog>
    );
}